import { makeStyles } from 'tss-react/mui';
import { addProductBackgroundColor } from '../../../Theme';

export const useSearchFieldStyles = makeStyles()(() => ({
  searchTextField: {
    backgroundColor: addProductBackgroundColor,
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: 6,
    },
  },
  searchInput: {
    height: 32,
    borderRadius: 6,
  },
  searchIcon: {
    marginRight: 4,
  },
}));
